<form [formGroup]="registrationNumbers">
  @if (uiConfiguration.lienDetailsConfiguration?.showAssignorRegistrationNumbers) {
    <div class="padding padding-bottom-5"
      >
      <h3>{{ uiConfiguration.lienDetailsConfiguration!.assignorRegistrationNumbersTitle }}</h3>
      @if ((this.order.lien?.assignorRegistrationNumbers?.length ?? 0) > 0) {
        <table mat-table
          [dataSource]="assignorRegistrationNumbers" multiTemplateDataRows class="fixed-table"
          data-testid="assignor-registration-numbers-table">
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let number" data-testid="assignor-registration-numbers-number">
              {{ number }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let num; let i = dataIndex">
              <button color="primary" mat-icon-button [matMenuTriggerFor]="menu" [attr.aria-label]="'orders.moreActions' | transloco"
                data-testid="assignor-registration-numbers-actions">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <div #menuContainer>
                  <button mat-menu-item [attr.aria-label]="'orders.copyPaarties' | transloco"
                    data-testid="assignor-registration-number-copy-parties-button"
                    (click)="openCopyPartiesToAssignorsDialog(num)">
                    <mat-icon color="primary">content_copy</mat-icon>
                    <span>{{ 'orders.copyParties' | transloco }}</span>
                  </button>
                  <button mat-menu-item [attr.aria-label]="'orders.deleteAssignorRegistrationNumber' | transloco"
                    data-testid="assignor-registration-number-delete-button"
                    (click)="removeAssignorRegistrationNumber(i)">
                    <mat-icon color="warn">delete</mat-icon>
                    <span>{{ 'common.buttons.delete' | transloco }}</span>
                  </button>
                </div>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let party; columns: displayedColumns;">
          </tr>
        </table>
      }
      @if((order.lien?.assignorRegistrationNumbers?.length ?? 0) > 10) {
        <mat-paginator #paginator
          (page)="onAssignorRegistrationNumberPaging($event)"
          [length]="order.lien?.assignorRegistrationNumbers?.length ?? 0"
          [pageIndex]="assignorRegNumsPageIndex"
          [pageSize]="pageSize"
          [showFirstLastButtons]="true"
          [hidePageSize]="true"
          [attr.aria-label]="'orders.selectAssignorRegistrationNumbersPage' | transloco">
        </mat-paginator>
      }
      <div class="flex-container-vertical-center">
        <div class="flex-item-6">
          <div class="validated-form-field-container flex-container">
            <mat-form-field subscriptSizing="dynamic" class="form-field flex-item" appearance="outline">
              <mat-label>{{ getAssignorRegistrationNumbersLabel() }}</mat-label>
              <input matInput data-testid="add-assignor-registration-number-field"
                [placeholder]="getAssignorRegistrationNumbersLabel()" formControlName="assignorRegistrationNumber" />
            </mat-form-field>
            <lib-error-bubble [control]="registrationNumbers.controls['assignorRegistrationNumber']"
            [message]="assignorRegistrationNumberError$"></lib-error-bubble>
          </div>
        </div>
        <div class="padding-sides-15 flex-item-1">
          <button [disabled]="!registrationNumbers.controls['assignorRegistrationNumber'].value"
            (click)="addAssignorRegistrationNumbers()" mat-mini-fab color="primary"
            [attr.aria-label]="'orders.addRegistrationNumber' | transloco" data-testid="add-assignor-registration-number-button">
            <mat-icon>add</mat-icon>
          </button>
          <span class="padding-sides-15">
            <button mat-mini-fab (click)="onClearAllAssignorRegistrationNumbers()"
              [disabled]="(order.lien?.assignorRegistrationNumbers?.length ?? 0) === 0"
              [attr.aria-label]="'orders.clearAllAssignorRegistrationNumbers' | transloco"
              data-testid="clear-assignor-registration-numbers-button">
              <mat-icon [matTooltip]="'orders.clearAll' | transloco" matTooltipClass="reghub-tooltip">clear_all</mat-icon>
            </button>
          </span>
          <button mat-mini-fab [attr.aria-label]="'orders.uploadFileOfAssignorRegistrationNumbers' | transloco"
            data-testid="assignor-registration-numbers-file-upload">
            <mat-icon [matTooltip]="'orders.uploadACsvOrTxtFile' | transloco"
            matTooltipClass="reghub-tooltip" role="button" tabindex="0" aria-hidden="false" [attr.aria-label]="'orders.uploadRegistrationNumbersFile' | transloco"
              (click)="fileInput.click()" (keydown.enter)="fileInput.click()"
              (keydown.space)="$event.preventDefault(); fileInput.click()">upload_file</mat-icon>
          </button>
          <input #fileInput hidden="true" type="file" onclick="this.value = null"
            (change)="onAssignorRegistrationNumbersFileSelected($event)" />
        </div>
      </div>
    </div>
  }

  @if (uiConfiguration.lienDetailsConfiguration?.showAssigneeRegistrationNumbers) {
    <div class="padding">
      <h3>{{ 'orders.assigneeRegistrationNumbers' | transloco }}</h3>
      @if ((this.order.lien?.assigneeRegistrationNumbers?.length ?? 0) > 0) {
        <table mat-table
          [dataSource]="assigneeRegistrationNumbers" multiTemplateDataRows class="fixed-table"
          data-testid="assignee-registration-numbers-table">
          <ng-container matColumnDef="number">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let number" data-testid="assignee-registration-numbers-number">
              {{ number }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let num; let i = dataIndex">
              <button color="primary" mat-icon-button [matMenuTriggerFor]="menu" [attr.aria-label]="'orders.moreActions' | transloco"
                data-testid="assignee-registration-numbers-actions">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <div #menuContainer>
                  <button mat-menu-item [attr.aria-label]="'orders.copyParties' | transloco"
                    data-testid="assignee-registration-number-copy-parties-button"
                    (click)="openCopyPartiesToAssigneesDialog(num)">
                    <mat-icon color="primary">content_copy</mat-icon>
                    <span>{{ 'orders.copyParties' | transloco }}</span>
                  </button>
                  <button mat-menu-item [attr.aria-label]="'orders.deleteAssigneeRegistrationNumber' | transloco"
                    data-testid="assignee-registration-number-delete-button"
                    (click)="removeAssigneeRegistrationNumber(i)">
                    <mat-icon color="warn">delete</mat-icon>
                    <span>{{ 'common.buttons.delete' | transloco }}</span>
                  </button>
                </div>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let party; columns: displayedColumns;">
          </tr>
        </table>
      }
      @if((order.lien?.assigneeRegistrationNumbers?.length ?? 0) > 10) {
        <mat-paginator #paginator
          (page)="onAssigneeRegistrationNumberPaging($event)"
          [length]="order.lien?.assigneeRegistrationNumbers?.length ?? 0"
          [pageIndex]="assigneeRegNumsPageIndex"
          [pageSize]="pageSize"
          [showFirstLastButtons]="true"
          [hidePageSize]="true"
          [attr.aria-label]="'orders.selectAssigneeRegistrationNumbersPage' | transloco">
        </mat-paginator>
      }
      <div class="flex-container-vertical-center">
        <div class="flex-item-6">
          <div class="validated-form-field-container flex-container">
            <mat-form-field subscriptSizing="dynamic" class="form-field flex-item" appearance="outline">
              <mat-label>{{ 'orders.assigneeRegistrationNumber' | transloco }}</mat-label>
              <input matInput data-testid="add-assignee-registration-number-field"
                [placeholder]="'orders.assigneeRegistrationNumber' | transloco" formControlName="assigneeRegistrationNumber" />
            </mat-form-field>
            <lib-error-bubble [control]="registrationNumbers.controls['assigneeRegistrationNumber']"
            [message]="assigneeRegistrationNumberError$"></lib-error-bubble>
          </div>
        </div>
        <div class="padding-sides-15 flex-item-1">
          <button [disabled]="!registrationNumbers.controls['assigneeRegistrationNumber'].value"
            (click)="addAssigneeRegistrationNumbers()" mat-mini-fab color="primary"
            [attr.aria-label]="'orders.addAssigneeRegistrationNumber' | transloco" data-testid="add-assignee-registration-number-button">
            <mat-icon>add</mat-icon>
          </button>
          <span class="padding-sides-15">
            <button mat-mini-fab (click)="onClearAllAssigneeRegistrationNumbers()"
              [disabled]="(order.lien?.assigneeRegistrationNumbers?.length ?? 0) === 0"
              [attr.aria-label]="'orders.clearAllAssigneeRegistrationNumbers' | transloco"
              data-testid="clear-assignee-registration-numbers-button">
              <mat-icon [matTooltip]="'orders.clearAll' | transloco" matTooltipClass="reghub-tooltip">clear_all</mat-icon>
            </button>
          </span>
          <button mat-mini-fab [attr.aria-label]="'orders.uploadFileOfAssigneeRegistrationNumbers' | transloco"
            data-testid="assignee-registration-numbers-file-upload">
            <mat-icon [matTooltip]="'orders.uploadACsvOrTxtFile' | transloco"
            matTooltipClass="reghub-tooltip" role="button" tabindex="0" aria-hidden="false" [attr.aria-label]="'orders.uploadRegistrationNumbersFile' | transloco"
              (click)="fileInput.click()" (keydown.enter)="fileInput.click()"
              (keydown.space)="$event.preventDefault(); fileInput.click()">upload_file</mat-icon>
          </button>
          <input #fileInput hidden="true" type="file" onclick="this.value = null"
            (change)="onAssigneeRegistrationNubmersFileSelected($event)" />
        </div>
      </div>
      <h3>{{ 'orders.additionalDetails' | transloco }}</h3>
    </div>
  }
</form>

<app-qc-lien-details [uiConfiguration]="uiConfiguration"></app-qc-lien-details>